
import React from 'react';
import {map, uniq} from 'lodash';
import {COLOR_QUALITATIVE_CATEGORICAL} from '../chart-colors.js';
import {
    BRUSH_POSITION_END,
    CHART_X_AXIS_PADDING_LEFT,
    CHART_X_AXIS_PADDING_RIGHT,
    getBrushProps
} from '../chart-util.js';

export const LINE_TYPES = {
    BASIS: 'basis',
    BASIS_CLOSED: 'basisClosed',
    BASIS_OPEN: 'basisOpen',
    LINEAR: 'linear',
    LINEAR_CLOSED: 'linearClosed',
    NATURAL: 'natural',
    MONOTONE_X: 'monotoneX',
    MONOTONE_Y: 'monotoneY',
    MONOTONE: 'monotone',
    STEP: 'step',
    STEP_BEFORE: 'stepBefore',
    STEP_AFTER: 'stepAfter'
};


export const getLineChartConfig = (configChart, chartData) => {

    const {
        chartWidth = '100%',
        chartHeight = 300,
        configLines: {
            plotLines = [],
            isHighLightLineOnClick = false,
            lineType = LINE_TYPES.MONOTONE,
            lineWidth = 1,
            lineColors = COLOR_QUALITATIVE_CATEGORICAL,
            isDashedLine = false,
            strokeDashArray = ['10 10'],
            lineStrokeIndex = plotLines.length < 4 ? '3' : plotLines.length,
            lineOnClickHandler = () => {},
            isAnimation = false
        },
        configXAxis: {
            xAxisKey,
            xAxisTickFormatter,
            xAxisPaddingLeft = CHART_X_AXIS_PADDING_LEFT,
            xAxisPaddingRight = CHART_X_AXIS_PADDING_RIGHT
        },
        configYAxis: {
            yAxisTickFormatter
        },
        configLegends: {
            legendLabels,
            legendIcon = 'square',
            isLegendTextColorSameAsChartColor = false,
            isToggleChartOnClickOfLegend = false,
            isGroupLegend = false
        } = {},
        isVisibleHorizontalGrid = false,
        isBrushVisible = false,
        tooltipContent
        /* TODO: create custom tooltip */
        // tooltipContent = <CustomTooltip />
    } = configChart || {};

    return {
        chartWidth,
        chartHeight,
        plotLines,
        getLineKeys: getLineKeys,
        getGroupLineKeys: getGroupLineKeys,
        isHighLightLineOnClick,
        lineType,
        lineWidth,
        lineColors: lineColors[lineStrokeIndex] ? lineColors[lineStrokeIndex] : lineColors['default'],
        isDashedLine,
        strokeDashArray,
        isAnimation,
        lineOnClickHandler,
        xAxisKey,
        xAxisPaddingLeft,
        xAxisPaddingRight,
        xAxisTickFormatter,
        yAxisTickFormatter,
        legendLabels,
        legendIcon,
        legendTextColor: isLegendTextColorSameAsChartColor ? '' : '#000000',
        isToggleChartOnClickOfLegend,
        isGroupLegend,
        isVisibleHorizontalGrid,
        tooltipContent,
        brush: isBrushVisible ? {
            ...getBrushProps(BRUSH_POSITION_END, 30, chartData.length),
            tickFormatter: tickValue => tickValue
        } : {}
    };
};

const getLineKeys = plotLines => map(plotLines, eachLine => eachLine.lineKey);

const getGroupLineKeys = plotLines => uniq(map(plotLines, eachLine => eachLine.groupKey));
